export default {"src":"/_next/static/media/appStore.b12e45e1.svg","height":80,"width":250,"blurWidth":0,"blurHeight":0};